import { TTabState, TabAction } from "./tab.state";
import { SearchActions } from "~/types/actions.enum";

// ✅ Tab reducer logic
export const tabReducer = (state: TTabState, action: TabAction): TTabState => {
    switch (action.type) {
        case SearchActions.SET_TAB_ITEMS:
            return {
                ...state,
                tabs: action.payload
            };

        case SearchActions.SET_ACTIVETAB:
            return { ...state, tab: action.payload };

        case SearchActions.SET_ACTIVETAB_BY_KEY: {
            const tabItem = state.tabs.find(item => item.key === action.payload) ?? null;
            return { ...state, tab: tabItem };
        }

        default:
            return state;
    }
};
